import React, { useRef } from 'react'

import { Box, Button, TextField } from '@mui/material'

import SearchIcon from '@mui/icons-material/Search'

import { useFormik } from 'formik'

import { checkDispatchFormInitialValues, validationSchema } from '../config'

import { checkBusiness } from '../actions/checkBusiness'

/*
Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se mejora estado global en base a useReducer + Context
*/

export const WorkOrderInput = () => {
  const { resetState, getWorkOrderStatus } = checkBusiness()

  const UseFocus = () => {
    const htmlElRef: any = useRef(null)
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus()
    }

    return [htmlElRef, setFocus]
  }

  const formik = useFormik({
    initialValues: checkDispatchFormInitialValues,

    onSubmit: async (values) =>
      await getWorkOrderStatus(Number(values.workOrderInput)),
    validationSchema
  })

  const handleReset = () => {
    resetState()
    formik.resetForm()
  }

  const [input1Ref, setInput1Focus] = UseFocus()

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box
        component='div'
        display='flex'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='center'
        padding='10px 10px 0 10px'
      >
        <TextField
          id='workOrderInput'
          name='workOrderInput'
          value={formik.values.workOrderInput}
          type='text'
          onChange={(e) => {
            setInput1Focus()
            formik.handleChange(e)
          }}
          variant='outlined'
          fullWidth
          label='Ingresar/Escanear ID'
          disabled={formik.isSubmitting}
          autoFocus
          inputProps={{
            autoComplete: false
          }}
          ref={input1Ref}
        />
        <Button
          type='submit'
          disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
          variant='contained'
          color='primary'
          style={{
            height: '56px'
          }}
        >
          <SearchIcon />
        </Button>
      </Box>
      <Box
        component='div'
        display='flex'
        flexDirection='row'
        flexWrap='nowrap'
        alignItems='center'
        padding='5px 10px'
      >
        <Button
          fullWidth
          variant='outlined'
          color='primary'
          onClick={handleReset}
          disabled={formik.isSubmitting}
        >
          Limpiar
        </Button>
      </Box>
    </form>
  )
}
